import { Award } from 'lucide-react';
import type { TrainingProgressCell as Cell } from '../../../hooks/useTrainingProgress';

const TONE: Record<Cell['status'], string> = {
  passed: 'bg-success-soft/15 text-success-soft-fg ring-success-soft/25',
  in_progress: 'bg-warning-soft/15 text-warning-soft-fg ring-warning-soft/25',
  not_started: 'bg-neutral-soft/10 text-fg-muted ring-line/15',
};

const LABEL: Record<Cell['status'], string> = {
  passed: 'Passed',
  in_progress: 'In progress',
  not_started: 'Not started',
};

/** One matrix cell: a status chip button opening the attempt history. */
export function ProgressCell({
  cell,
  graded = true,
  onOpen,
}: {
  cell: Cell;
  /** False = an unmarked assessment, which is completed rather than passed. */
  graded?: boolean;
  onOpen: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-token-sm px-2 py-1 text-xs font-medium ring-1 transition-opacity hover:opacity-80 ${TONE[cell.status]}`}
    >
      {!graded && cell.status === 'passed' ? 'Complete' : LABEL[cell.status]}
      {cell.best_score != null ? <span className="tabular-nums">· {cell.best_score}%</span> : null}
      {cell.attempts > 1 ? (
        <span className="tabular-nums opacity-75">({cell.attempts} tries)</span>
      ) : null}
      {cell.certificate ? <Award className="h-3 w-3" aria-label="Certificate issued" /> : null}
      {cell.optional ? (
        <span className="opacity-60" title="Optional — self-enrolled">
          · opt
        </span>
      ) : null}
    </button>
  );
}
